import { GridRenderCellParams } from '@mui/x-data-grid';
import { AgentPortalFeatureCode } from '@wallet-manager/pfh-pmp-node-def-types';

import { COLUMN_WIDTH } from '../../../../constants/ColumnWidth';
import { usePermission } from '../../../../hooks';
import { useGenGridCol } from '../../../../utils/ComponentHelper';
import { TableColumnKey } from '../types/Table';
import { IProps } from 'react-qrcode-logo';

const useTableColumns = () => {
    const { hasPermission } = usePermission();
    
      const columns = [
        useGenGridCol(TableColumnKey.distributorAgentId, {
          minWidth: 200,
        }),
        useGenGridCol(TableColumnKey.orderId, {
          minWidth: 200,
        }),
        useGenGridCol(TableColumnKey.orderSequence, {
          minWidth: 200,
        }),
        useGenGridCol(TableColumnKey.programName, {
          minWidth: 200,
        }),
        useGenGridCol(TableColumnKey.cardProfileName, {
          minWidth: 200,
        }),
        useGenGridCol(TableColumnKey.status, {
          minWidth: 200,
        }),
        useGenGridCol(TableColumnKey.pfhNumber, {
          minWidth: 200,
        }),
        useGenGridCol(TableColumnKey.embossedName, {
          minWidth: 200,
        }),
        useGenGridCol(TableColumnKey.cardNumber, {
          minWidth: 200,
        }),
        useGenGridCol(TableColumnKey.panLast4, {
          minWidth: 200,
        }),
        useGenGridCol(TableColumnKey.cardType, {
          minWidth: 200,
        }),
        useGenGridCol(TableColumnKey.cardCreatedTime, {
          minWidth: COLUMN_WIDTH.CreatedDate.MinWidth,
        }),
        useGenGridCol(TableColumnKey.cardExpiryTime, {
          minWidth: COLUMN_WIDTH.CreatedDate.MinWidth,
        }),
        useGenGridCol(TableColumnKey.e6CardStatus, {
          minWidth: 200,
        }),
        useGenGridCol(TableColumnKey.statusUpdateTime, {
          minWidth: COLUMN_WIDTH.CreatedDate.MinWidth,
        }),
        useGenGridCol(TableColumnKey.preCreatedCard, {
          minWidth: 150,
        }),
        useGenGridCol(TableColumnKey.imported, {
          minWidth: 150,
        }),
        useGenGridCol(TableColumnKey.blocked, {
          minWidth: 150,
        }),
        useGenGridCol(TableColumnKey.reissued, {
          minWidth: 150,
        }),
        useGenGridCol(TableColumnKey.reissueOrderId, {
          minWidth: 250,
        }),
        useGenGridCol(TableColumnKey.originalCardNumber, {
          minWidth: 200,
        }),
        useGenGridCol(TableColumnKey.deactivatedOriginalCardOnActivation, {
          minWidth: 300,
        }),
        useGenGridCol(TableColumnKey.cardActivationTime, {
          minWidth: COLUMN_WIDTH.CreatedDate.MinWidth,
        }),
        useGenGridCol(TableColumnKey.creationTime, {
          minWidth: COLUMN_WIDTH.CreatedDate.MinWidth,
        }),
        useGenGridCol(TableColumnKey.lastModifiedTime, {
          minWidth: COLUMN_WIDTH.LastModifiedDate.MinWidth,
        }),
      ];
    
      return columns;
}

export default useTableColumns;